
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InjectFlags } from '@angular/compiler/src/core';
import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import { FormBuilder, Validators } from '@angular/forms';
import { AdminRightServiceService } from '../shared/admin.rights.service';
class ImageSnippet {
  pending: boolean = false;
  status: string = 'init';

  constructor(public src: string, public file: File) {}
}
@Component({
  selector: 'app-editdriver',
  templateUrl: './editdriver.component.html',
  styleUrls: ['./editdriver.component.scss']
})
export class EditdriverComponent implements OnInit {
  editdata:any
  formSumbitted: boolean=false;
  driverId: any;
  selectedFile!: ImageSnippet;
  selectedRcFile:ImageSnippet;
  editDriver: any;
  SelectedValue:any;
  driverimage:any;
  imagetype:string="Logo"
  driverrc: any;
  driverlicence: any;
  driveraddressproof: any;
driverid:any;
  selectedlicence: ImageSnippet;
  selectedidproof: ImageSnippet;
  selectedaddress: ImageSnippet;
  editdetails: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,public adminRules:AdminRightServiceService,private fb: FormBuilder,private snack:MatSnackBar,public service:CommonService,public dialog: MatDialog,private router: Router,private dialogRef: MatDialogRef<EditdriverComponent>) { }
  ngOnInit(): void {
    this.editdetails=this.data

    this.driverEditForm();
  if (this.data.name) this.editDriver.controls.name.setValue(this.data.name)
if (this.data.email) this.editDriver.controls.email.setValue(this.data.email)
if (this.data.vehicleName) this.editDriver.controls.vehicleName.setValue(this.data.vehicleName)
if (this.data.phoneNo) this.editDriver.controls.phoneNo.setValue(this.data.phoneNo)
if (this.data.vehicleType) this.editDriver.controls.vehicleType.setValue(this.data.vehicleType)
if (this.data.vehicleNo) this.editDriver.controls.vehicleNo.setValue(this.data.vehicleNo)
if (this.data.licenceNo) this.editDriver.controls.licenceNo.setValue(this.data.licenceNo)
if (this.data.licenceValidity) this.editDriver.controls.licenceValidity.setValue(this.data.licenceValidity)
if (this.data.rcValidity) this.editDriver.controls.rcValidity.setValue(this.data.rcValidity)
this.driverimage=this.data.driverImage
this.driverrc=this.data.uploadedDocument.rc
this.driverlicence=this.data.uploadedDocument.licence
this.driverid=this.data.uploadedDocument.idProof
this.driveraddressproof=this.data.uploadedDocument.addressProof
  
}
  closeDialog() {
    this.dialogRef.close();
  }
 
  driverEditForm() {
    this.editDriver = this.fb.group({
      name: ['', [Validators.required]],
    email: ['', [Validators.required]],
    phoneNo: ['', [Validators.required]],
      vehicleType : ['',[Validators.required]],
      vehicleNo:['',[Validators.required]],
      licenceNo:['',[Validators.required]],
      licenceValidity:['',[Validators.required]],
      rcValidity:['',[Validators.required]],
      vehicleName:['',[Validators.required]]
    });
  }
  ChangeList(e){
    this.SelectedValue=e.target.value
  }
  private onSuccess() {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'ok';
  }
  private onError() {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'fail';
    this.selectedFile.src = '';
  }
  processFile(imageInput: any) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      this.selectedFile = new ImageSnippet(event.target.result, file);

      this.selectedFile.pending = true;
      this.service.uploadImage(this.selectedFile.file).subscribe(
        (res:any) => {
          this.onSuccess();
          localStorage.setItem('imageUrl', JSON.stringify(res.data.location))
          this.driverimage=res.data.location
        },
        (err:any) => {
          this.onError();
        })
    });
    reader.readAsDataURL(file);
  }
  processFile1(rc: any) {
    const file: File = rc.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      this.selectedRcFile = new ImageSnippet(event.target.result, file);

      this.selectedRcFile.pending = true;
      this.service.uploadImage(this.selectedRcFile.file).subscribe(
        (res:any) => {
          this.onSuccess();
          localStorage.setItem('Rcimage', JSON.stringify(res.data.location))
          this.driverrc=res.data.location
        },
        (err:any) => {
          this.onError();
        })
    });
    reader.readAsDataURL(file);
  }
  licencefile(licence: any) {
    const file: File = licence.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      this.selectedlicence = new ImageSnippet(event.target.result, file);

      this.selectedlicence.pending = true;
      this.service.uploadImage(this.selectedlicence.file).subscribe(
        (res:any) => {
          this.onSuccess();
          localStorage.setItem('licenceimage', JSON.stringify(res.data.location))
        this.driverlicence=res.data.location;
        },
        (err:any) => {
          this.onError();
        })
    });
    reader.readAsDataURL(file);
  }
  uploadidproof(idproof){
    const file: File = idproof.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      this.selectedidproof = new ImageSnippet(event.target.result, file);

      this.selectedidproof.pending = true;
      this.service.uploadImage(this.selectedidproof.file).subscribe(
        (res:any) => {
          this.onSuccess();
          localStorage.setItem('idproof', JSON.stringify(res.data.location))
          this.driverid=res.data.location;
        },
        (err:any) => {
          this.onError();
        })
    });
    reader.readAsDataURL(file);
  }
  uploadaddress(address){
    const file: File = address.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      this.selectedaddress = new ImageSnippet(event.target.result, file);

      this.selectedaddress.pending = true;
      this.service.uploadImage(this.selectedaddress.file).subscribe(
        (res:any) => {
          this.onSuccess();
          localStorage.setItem('address', JSON.stringify(res.data.location))
          this.driveraddressproof=res.data.location;
        },
        (err:any) => {
          this.onError();
        })
    });

    reader.readAsDataURL(file);
  }
  editdriverdetail(valid: any){
    this.formSumbitted = true
    this.driverId =this.editdata._id
    if(valid){
      let req ={
        "name" : this.editDriver.controls.name.value,
        "phoneNo": this.editDriver.controls.phoneNo.value,
        "email": this.editDriver.controls.email.value,
        "vehicleType": this.editDriver.controls.vehicleType.value,
        "vehicleNo":this.editDriver.controls.vehicleNo.value, 
        "licenceNo":this.editDriver.controls.licenceNo.value,  
        "licenceValidity": this.editDriver.controls.licenceValidity.value, 
        "rcValidity":this.editDriver.controls.rcValidity.value ,
       "vehicleName":this.editDriver.controls.vehicleName.value,
        "uploadedDocument": {
          "rc": this.driverrc,
          "licence": this.driverlicence,
          "idProof": this.driverid,
          "addressProof": this.driveraddressproof,
        },
      
        "driverImage": this.driverimage,
        }
        
      this.service.editdriver(req,  this.driverId).subscribe((data : any)=> {

        if(data.message == "Success"){
          this.snack.open("Edit successfully",'',{
            duration:1000,
           verticalPosition:'top',
           horizontalPosition: 'end',
          })
          // this.router.navigate(['/customer'])
          this.closeDialog()
        }else{
          alert(" something went wrong");
          this.editDriver.reset();
        }
    })
  }
}
}


